<div
  [ngClass]="{'h-full': !(quorumGalleryTemplate || quorumLibraryTemplate),'h-screen': (quorumGalleryTemplate || quorumLibraryTemplate) }"
  class="flex flex-row w-full">
  <div id="main" class="flex flex-col h-full w-4/12 min-w-min max-w-xs bg-grey-800">
    <form [formGroup]="templateForm" class="flex flex-row flex-wrap w-full px-4 pt-4">
      <mat-form-field class="text-white w-full" color="accent" appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput name="name" formControlName="name" autocomplete="off">
      </mat-form-field>
      <mat-form-field class="text-white w-full" color="accent" appearance="outline">
        <mat-label>Subject</mat-label>
        <input matInput name="subject" formControlName="subject" autocomplete="off">
      </mat-form-field>
      <mat-form-field class="text-white w-full" color="accent" appearance="outline">
        <mat-label>Description</mat-label>
        <input matInput name="description" formControlName="description" autocomplete="off">
      </mat-form-field>
    </form>

    <ng-container
      *ngIf="{ selectedLanguage: templateFacade.selectedLanguage$ | async, supportedLanguages: this.templateFacade.supportedLanguages$ | async} as languageData">
      <div *ngIf="languageData.supportedLanguages?.length > 1" class="flex flex-row place-content-center pb-4">
        <mat-button-toggle-group [(ngModel)]="selectedLanguage" (change)="selectLanguage($event.value)"
          name="selectedLanguage" aria-label="Select Language">
          <mat-button-toggle *ngFor="let language of languageData.supportedLanguages | orderBy"
            [value]="language">{{language}}
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </ng-container>
    <div class="flex flex-row place-content-center pb-4">
      <mat-button-toggle-group [(ngModel)]="layoutView" name="layoutView" aria-label="Layout View">
        <mat-button-toggle value="layout">Layout</mat-button-toggle>
        <mat-button-toggle value="layers">Layers</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div class="flex-1 flex flex-col overflow-auto">
      <div [ngClass]="{'hidden': layoutView !== 'layout'}" #blocks>
        <div id="blocks-container"></div>
      </div>

      <div [ngClass]="{'hidden': layoutView !== 'layers'}" #layers>
        <div id="layers-container"></div>
      </div>
    </div>
  </div>
  <div id="gjs" #gjs>
  </div>
  <div class="flex flex-col h-full w-4/12 min-w-min max-w-xs bg-grey-800 overflow-auto">
    <div id="traits-container"></div>
    <div id="styles-container"></div>
  </div>
</div>